const Tribe=[
    {id:1,
     name:'Brennen',
     image: require('../../assets/brennen.svg'),
     rule:"Seleziona almeno due ABILITA' FISICHE affinche il tuo personaggio sia considerato valido, per avere maggiori informazioni clicca sul nome dell'abilità o vedi il regolamento",
     site:'https://files.avernum.org/tribu/5edb4502622025ee3d20f31219cbcdbf.pdf'},
     {id:2,
        name:'Kumpania',
        image:require('../../assets/kumpania.svg'),
        rule:"Seleziona un'ABILITA' di ogni tipo affinche il tuo personaggio sia considerato valido, per avere maggiori informazioni clicca sul nome dell'abilità o vedi il regolamento",
        site:'https://files.avernum.org/tribu/54161ec65f4cf64e003780d270761c91.pdf'},
        {id:3,
            name:'Priorato di Aletheia',
            image:require('../../assets/priorato.svg'),
            rule:"Seleziona un'ABILITA' di ogni tipo affinche il tuo personaggio sia considerato valido, per avere maggiori informazioni clicca sul nome dell'abilità o vedi il regolamento",
            site:'https://files.avernum.org/tribu/8611a96c6dc2eb69f1770bf620e9d7f2.pdf'},
            {id:4,
                name:'Popolo di Zao',
                image:require('../../assets/popolo.svg'),
                rule:"Seleziona un'ABILITA' di ogni tipo affinche il tuo personaggio sia considerato valido, per avere maggiori informazioni clicca sul nome dell'abilità o vedi il regolamento",
                site:'https://files.avernum.org/tribu/faf64408351a8ca155c8b0edc8bc9d99.pdf'},
                {id:5,
                    name:'Volkron',
                    image:require('../../assets/volkron.svg'),
                    rule:"Seleziona un'ABILITA' di ogni tipo affinche il tuo personaggio sia considerato valido, per avere maggiori informazioni clicca sul nome dell'abilità o vedi il regolamento",
                    site:'https://files.avernum.org/tribu/540b08d997427302a2be77d4e988e7a5.pdf'},
    ]

    export {Tribe}

    